module.exports = __webpack_public_path__ + "img/Bomba ZN.2b67b9ee.png";